import Vue from 'vue'
import Vuex, { ActionTree, Dispatch } from 'vuex'
import auth from './vuexModules/auth'
import user from './vuexModules/user'
import contact from './vuexModules/contact'
import report from './vuexModules/report'
import exportProof from './vuexModules/exportProof'
import country from './vuexModules/country'
import customer from './vuexModules/customer'
import provider from './vuexModules/provider'
import tag from './vuexModules/tag'
import serviceLevel from './vuexModules/serviceLevel'
import eventInfo from './vuexModules/eventInfo'
import personalSettings from './vuexModules/personalSettings'
import parcelFilter from './vuexModules/parcelFilter'
import news from './vuexModules/news'
import reference from './vuexModules/reference'
import migrationErrors from './vuexModules/migrationErrors'
import userManagment from './vuexModules/userManagment'
import pudo from './vuexModules/pudo'
import dropCost from './vuexModules/dropCost'
import problemReport from './vuexModules/problemReport'
import deadline from './vuexModules/deadline'
import dailyCargo from './vuexModules/dailyCargo'
import profiler from './vuexModules/profiler'
import adhocDrive from './vuexModules/adhocDrive'
import currency from './vuexModules/currency'
import serviceLeg from './vuexModules/serviceLeg'
import vehicle from './vuexModules/vehicle'
import preCarriageRoutes from './vuexModules/preCarriageRoutes'
import linehaulRoad from './vuexModules/linehaulRoad'

class IndexState {
  public isLoaded:boolean = false
  public isLoading:boolean = false
}

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    contact,
    report,
    exportProof,
    country,
    customer,
    provider,
    tag,
    serviceLevel,
    eventInfo,
    parcelFilter,
    news,
    reference,
    migrationErrors,
    personalSettings,
    userManagment,
    pudo,
    dropCost,
    problemReport,
    deadline,
    dailyCargo,
    profiler,
    adhocDrive,
    currency,
    serviceLeg,
    vehicle,
    preCarriageRoutes,
    linehaulRoad
  },

  actions: <ActionTree<IndexState, any>> {
    init ({ dispatch, state }: {dispatch:Dispatch, state:IndexState}): Promise<any> {
      if (state.isLoaded || state.isLoading) {
        return
      }
      state.isLoading = true
      return dispatch('user/getUserIdentity').then(() => {
        return Promise.all([
          dispatch('country/loadCountries'),
          dispatch('customer/loadCustomers'),
          dispatch('provider/loadProviders'),
          dispatch('provider/loadActiveProviders'),
          dispatch('tag/loadTags'),
          dispatch('serviceLevel/loadServiceLevels'),
          dispatch('eventInfo/loadEventInfos'),
          dispatch('news/loadNews'),
          dispatch('reference/loadReferences'),
          dispatch('userManagment/loadRoleList'),
          dispatch('migrationErrors/loadMigrationErrors'),
          dispatch('personalSettings/loadPersonalSettings'),
          dispatch('problemReport/loadResponsibleTypeList'),
          dispatch('dailyCargo/loadFlightRoutes'),
          dispatch('problemReport/loadProblemReportMeasures'),
          dispatch('currency/loadCurrencies'),
          dispatch('serviceLeg/loadService_Legs'),
          dispatch('vehicle/loadVehicles'),
          dispatch('preCarriageRoutes/loadPreCarriageRoutes'),
          dispatch('linehaulRoad/loadLinehaulRoadOptions')
        ])
      }).then(() => {
        // Load Report Columns after UserIdentity is loded
        return dispatch('report/loadReportColumnSetup')
      }).then(() => {
        // Load Report Columns after UserIdentity is loded
        return dispatch('exportProof/loadExportProofColumnSetup')
      }).then(() => {
        return dispatch('parcelFilter/initRootState')
      }).then(() => {
        state.isLoaded = true
        window.appReady = true
        state.isLoading = false
      }).catch((error) => {
        window.bus.$emit('openErrorModal', 'There was an problem loading the necessary data. Please try logging in again.')
        console.error('Error:', error)
        dispatch('auth/logout')
        state.isLoading = false
      })
    },
    reset ({ dispatch, state }:{dispatch:Dispatch, state:IndexState}) {
      state.isLoaded = false
      state.isLoading = false
      dispatch('contact/reset')
      dispatch('country/reset')
      dispatch('customer/reset')
      dispatch('provider/reset')
      dispatch('tag/reset')
      dispatch('eventInfo/reset')
      dispatch('parcelFilter/reset')
      dispatch('personalSettings/reset')
      dispatch('report/reset')
      dispatch('exportProof/reset')
      dispatch('serviceLevel/reset')
      dispatch('user/reset')
      dispatch('reference/reset')
      dispatch('userManagment/reset')
      dispatch('pudo/reset')
      dispatch('dropCost/reset')
      dispatch('problemReport/reset')
      dispatch('deadline/reset')
      dispatch('dailyCargo/reset')
      dispatch('profiler/reset')
      dispatch('adhocDrive/reset')
      dispatch('currency/reset')
      dispatch('serviceLeg/reset')
      dispatch('vehicle/reset')
      dispatch('preCarriageRoutes/reset')
      dispatch('linehaulRoad/reset')
    }
  }
})
